import React from "react";
import { isEmpty } from "lodash";
import { convertWithComma } from "@/util/priceUtil";
import { selectProductDetails } from "../../selectors";
import { useAppSelector } from "@/redux/store";
import HtmlParser from "@/components/html-parser";
import PaymentOptionItem from "./paymentOptionItem";
import { PayLaterOption } from "../types";
import "./style.scss";

const PaymentOptionsMob = ({
  payLaterOptions
}: {
  payLaterOptions: PayLaterOption[];
}) => {
  const item = useAppSelector(selectProductDetails);
  const normalPrice = Number(convertWithComma(item.price.current || 0));

  if (isEmpty(payLaterOptions)) {
    return null;
  }

  const firstMessage = payLaterOptions.find(
    (o: PayLaterOption) => o.messages?.length
  )?.messages[0];

  return (
    <div className="options_wrapper_resp">
      {firstMessage && (
        <div className="options_description">
          <HtmlParser html={firstMessage} />
        </div>
      )}
      <div className="pay_later_options">
        {payLaterOptions.map((option: PayLaterOption) => (
          <PaymentOptionItem
            key={option.paymentType}
            paymentSystemIcon={option.icon}
            paymentMode={option.paymentType}
            additionalUrl={option.additionalInfoUrl}
            normalPrice={normalPrice}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(PaymentOptionsMob);
